<template>
  <vue-chart type="line" :data="valuesChartData" :options="chartOptions"
             style="position:relative;width: 100%;height: 200px;"></vue-chart>
</template>
<script>
import VueChart from 'vue-chart-js'

export default {
  name: 'CallLogChart',
  components: { VueChart },
  data () {
    return {
      valuesChartData: {
        labels: [],
        datasets: [
          {
            type: 'line',
            steppedLine: false,
            lineTension: 0.1,
            label: this.$t('views.excmcalllog.lastMonthReport.durationSum'),
            data: [],
            pointRadius: 2,
            fill: false,
            borderColor: 'rgb(0, 0, 256)',
            backgroundColor: 'rgba(27, 126, 193, 0.1)',
            yAxisID: 'duration'
          },
          {
            type: 'line',
            steppedLine: false,
            lineTension: 0.1,
            label: this.$t('views.excmcalllog.list.answered'),
            data: [],
            pointRadius: 2,
            fill: false,
            borderColor: 'rgb(0, 128, 0)',
            backgroundColor: 'rgba(255, 0, 0, 0.1)',
            yAxisID: 'quantity'
          },
          {
            type: 'line',
            steppedLine: false,
            lineTension: 0.1,
            label: this.$t('views.exsborder.form.positions.quantity'),
            data: [],
            pointRadius: 2,
            fill: false,
            borderColor: 'rgb(255, 0, 0)',
            backgroundColor: 'rgba(255, 0, 0, 0.1)',
            yAxisID: 'quantity'
          }
        ]
      },
      chartOptions: {
        responsive: true,
        legend: {
          display: true
        },
        scales: {
          yAxes: [
            {
              id: 'duration',
              position: 'left',
              ticks: {
                beginAtZero: true
              }
            },
            {
              id: 'quantity',
              position: 'right',
              ticks: {
                beginAtZero: true
              }
            }
          ],
          xAxes: [{
            ticks: {
              autoSkip: false
              // display: false
            },
            gridLines: {
              color: 'rgba(0, 0, 0, 0)'
            }
          }]
        }
      }
    }
  },
  props: {
    callLogData: {}
  },
  created () {
    this.prepareDataFromProps()
  },
  methods: {
    prepareDataFromProps () {
      this.valuesChartData.datasets[0].data = []
      for (let i in this.callLogData.rowsdata) {
        this.valuesChartData.labels.push(this.callLogData.rowsdata[i].date)
        this.valuesChartData.datasets[0].data.push(this.callLogData.rowsdata[i].seconds)
        this.valuesChartData.datasets[1].data.push(this.callLogData.rowsdata[i].answered)
        this.valuesChartData.datasets[2].data.push(this.callLogData.rowsdata[i].quantity)
      }
    }
  }
}
</script>
